import React, { Component } from 'react';

class SPAXFHeader extends Component<any> {
  props: any;
  state: any;
  fetchHtml: any;
  constructor(props: any) {
    super(props);

    this.state = {
      headerContent: null,
    };
  }

  fetchExternalHTML = async () => {
    const response = await fetch(
      '/content/experience-fragments/workplace/page_structure_xfs/header-experience-fragment/master.html',
    );
    const xfHeaderContent = await response.text();
    const spaHeader = xfHeaderContent.substring(
      xfHeaderContent.indexOf('<body class="xf-web-container">') + 31,
      xfHeaderContent.indexOf('</body'),
    );
    this.setState({ headerContent: spaHeader });
    const node = document.getElementById('spa-header');
    node?.querySelectorAll('.cq-placeholder, meta, cq, .newpar').forEach(n => n.remove());
  };

  componentDidMount() {
    this.fetchExternalHTML();
  }

  render(): JSX.Element {
    return <div id={'spa-header'} dangerouslySetInnerHTML={{ __html: this.state.headerContent }} />;
  }
}

export default SPAXFHeader;
